(function () {
  window.RotaTheme?.register('mobile-navigation', {
    init(drawer) {
      const trigger = document.querySelector(`[aria-controls="${drawer.id}"]`);
      const backdrop = drawer.querySelector('[data-mobile-navigation-backdrop]');
      const closeButtons = Array.from(drawer.querySelectorAll('[data-mobile-navigation-close]'));
      const toggles = Array.from(drawer.querySelectorAll('[data-mobile-navigation-toggle]'));
      const panel = drawer.querySelector('.rm-mobile-drawer__panel') || drawer;
      if (!trigger) return null;

      const overlay = window.RotaOverlay?.create({
        panel: drawer,
        trigger,
        backdrop,
        modal: true,
        initialFocus: () => drawer.querySelector('[data-mobile-navigation-close]') || panel,
        onOpen: () => document.dispatchEvent(new CustomEvent('rm:mobile-navigation:open')),
        onClose: () => document.dispatchEvent(new CustomEvent('rm:mobile-navigation:close')),
      });

      const open = () => overlay?.open();
      const close = (options) => overlay?.close(options);
      const handleTriggerClick = () => open();
      const handleLinkClick = (event) => {
        if (event.target.closest('a[href]')) close({ restoreFocus: false });
      };

      trigger.addEventListener('click', handleTriggerClick);
      drawer.addEventListener('click', handleLinkClick);
      closeButtons.forEach((button) => button.addEventListener('click', close));
      toggles.forEach((button) => {
        button.addEventListener('click', () => {
          const expanded = button.getAttribute('aria-expanded') === 'true';
          button.setAttribute('aria-expanded', String(!expanded));
          const content = button.nextElementSibling;
          if (content) content.hidden = expanded;
        });
      });

      return () => {
        close({ restoreFocus: false });
        trigger.removeEventListener('click', handleTriggerClick);
        drawer.removeEventListener('click', handleLinkClick);
        closeButtons.forEach((button) => button.removeEventListener('click', close));
      };
    },
  });
})();
